import React from 'react'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'

interface StatusIconProps {
  value: boolean
}

export const StatusIcon: React.FC<StatusIconProps> = ({ value }) => {
  const Icon = value ? CheckIcon : CloseIcon
  const backgroundColor = value ? '#4caf50' : '#f48fb1'
  const colorText = value ? 'white' : 'black'

  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '2px 8px',
        borderRadius: '20px',
        backgroundColor,
        color: colorText,
        fontSize: '10px'
      }}
    >
      <Icon style={{ marginRight: '2px' }} />
    </div>
  )
}